<template>
  <payment-result-success-layout
    icon="mdi-bank-check"
    :title="$i18n.t('label.success')"
    :subtitle="subtitle"
  >
    <v-col
      class="py-0 my-1 text-right"
      cols="6"
    >
      Mandate Reference:
    </v-col>
    <v-col
      class="py-0 my-1 text-left"
      cols="6"
    >
      <span class="font-weight-bold">{{ mandateInfo.reference }}</span>
    </v-col>

    <v-col
      class="py-0 my-1 text-right"
      cols="6"
    >
      Creditor Name:
    </v-col>
    <v-col
      class="py-0 my-1 text-left"
      cols="6"
    >
      <span class="font-weight-bold">{{ creditorInfo.name }}</span>
    </v-col>

    <v-col
      class="py-0 my-1 text-right"
      cols="6"
    >
      Creditor ID (CID):
    </v-col>
    <v-col
      class="py-0 my-1 text-left"
      cols="6"
    >
      <span class="font-weight-bold">{{ creditorInfo.id }}</span>
    </v-col>
    <v-col cols="12">
      <v-link
        class="primary--text text-decoration-underline cursor-pointer"
        @click="showPaymentMethodMandate"
      >
        {{ $t('label.download_sepa_mandate') }}
      </v-link>
    </v-col>
  </payment-result-success-layout>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';

const props = defineProps({
  mandateInfo: { type: Object as PropType<{ reference?: string, url?: string}>, required: true },
});

const creditorInfo = computed(() => ({
  name: 'Guestplan',
  id: 'NL40ZZZ342518280000',
  address: 'Keizersgracht 188, Amterdam, 1016NA, NL',
}));

const subtitle = `${i18n.t('label.arrange_sepa_debit_your_bank')} ${i18n.t('label.sepa_debit_note_duration')}`;

async function showPaymentMethodMandate() {
  const newWin = window.open(
    props.mandateInfo?.url,
    'invoiceWindow',
    'height=600,width=600',
  );
  newWin!.document.close();
  newWin!.focus();
}

</script>
